module.exports = __webpack_public_path__ + "img/四诊仪.0374b4a8.png";